import { ChangeDetectionStrategy, Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Store } from "@ngxs/store";
import { ApplicationState } from "@vp/data-access/application";
import { OrganizationFeatures } from "@vp/models";
import { FeatureService } from "@vp/shared/features";
import { getUtcNow } from "@vp/shared/utilities";
import { NavigatorContact } from "../navigator-contacts/navigator-contacts.component";

@Component({
  selector: "vp-add-or-edit-navigator-contact",
  standalone: false,
  templateUrl: "./add-or-edit-navigator-contact.component.html",
  styleUrls: ["./add-or-edit-navigator-contact.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AddOrEditNavigatorContactComponent {
  action: "Add" | "Edit";
  contact: NavigatorContact;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { action: "Add" | "Edit"; contact: NavigatorContact },
    private readonly dialogRef: MatDialogRef<AddOrEditNavigatorContactComponent>,
    private readonly featureService: FeatureService,
    private readonly store: Store
  ) {
    this.action = data.action;
    this.contact = data.contact ?? ({} as NavigatorContact);
  }

  contactTypes$ = this.featureService.configurationListValue$(
    OrganizationFeatures.navigatorPortal,
    "contactTypes"
  );
  results$ = this.featureService.configurationListValue$(
    OrganizationFeatures.navigatorPortal,
    "resultOptions"
  );

  saveContact() {
    const loggedInUser = this.store.selectSnapshot(ApplicationState.loggedInUser);
    if (loggedInUser) {
      const utcNow = getUtcNow();
      if (this.action === "Add") {
        this.contact.active = true;
        this.contact.createdBy = loggedInUser.email;
        this.contact.lastUpdatedBy = loggedInUser.email;
        this.contact.createdDateTime = utcNow;
        this.contact.lastUpdatedDateTime = utcNow;
      } else {
        this.contact.lastUpdatedBy = loggedInUser.email;
        this.contact.lastUpdatedDateTime = utcNow;
      }
      this.dialogRef.close(this.contact);
    }
  }
}
